import { isDefined } from '@rhim/utils';
import React from 'react';

const MINIMUM_DEFAULT_DURATION = 4; // in seconds
const DURATION_PER_CHARACTER = 0.1; // in seconds

function extractTextFromNode(node: React.ReactNode): string {
  if (typeof node === 'string' || typeof node === 'number') {
    return node.toString();
  }

  if (Array.isArray(node)) {
    return node.map(extractTextFromNode).join('');
  }

  if (React.isValidElement(node)) {
    return extractTextFromNode((node.props as { children?: React.ReactNode }).children);
  }

  return '';
}

export function calculateDuration(duration?: number, message?: string | React.ReactElement, description?: string | React.ReactElement): number {
  if (isDefined(duration)) {
    return duration;
  }
  const messageLength = extractTextFromNode(message).length;
  const descriptionLength = extractTextFromNode(description).length;
  const totalLength = messageLength + descriptionLength;
  return Math.max(MINIMUM_DEFAULT_DURATION, totalLength * DURATION_PER_CHARACTER);
}
